export enum TypesSearchEnum {
  EMAIL = 'email',
  CPF = 'cpf',
  ID = 'id',
}
